import React, { useContext } from "react";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";
import { ConvertMmToPx, formatDate } from "../../../hooks/Method";

const MinimalPrintReceipt = ({ values, store }) => {
  const { t } = useTranslation();
  const { settings } = useContext(AppContext);
  const _store = store ? store : settings.store;

  return (
    <div
      style={{
        maxWidth: `${
          _store.receiptWidth ? ConvertMmToPx(_store.receiptWidth) : "220px"
        }px`,
        width: "100%",
        fontFamily: "monospace",
        fontSize: "10px",
        margin: 0,
        padding: 0,
        lineHeight: 1.4,
        fontWeight: 800,
        textTransform: "uppercase",
        color: "#000000 !important",
      }}
    >
      {/* Store Header */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "15px",
          paddingBottom: "10px",
          borderBottom: "2px double #333",
        }}
      >
        {/* Logo would go here */}
        <div
          style={{
            fontSize: "14px",
            fontWeight: "600",
            letterSpacing: "0.5px",
          }}
        >
          {_store.storeName}
        </div>
        <div
          style={{
            fontSize: "10px",
            color: "#00000",
            lineHeight: 1.3,
            marginTop: "5px",
          }}
        >
          {_store.address}
          <br />
          📞 {_store.phone}
        </div>
      </div>

      {/* Receipt Title */}
      <div
        style={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "12px",
          marginBottom: "15px",
        }}
      >
        {t("cashRegisterClosingReport")}
      </div>

      {/* Register Session Times */}
      <div
        style={{
          marginBottom: "15px",
          borderBottom: "1px solid #ddd",
          paddingBottom: "10px",
        }}
      >
        {values.id && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{t("registerCloseId")}:</span>
            <span>{values.id}</span>
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{t("openDate")}: </span>
          <span>{formatDate(values.openTime)}</span>
        </div>
        {values.closeTime && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{t("closeDate")}: </span>
            <span>{formatDate(values.closeTime)}</span>
          </div>
        )}
      </div>

      {/* Summary Section */}
      <div
        style={{
          marginBottom: "15px",
          borderBottom: "2px double #333",
          paddingBottom: "10px",
          textTransform: "uppercase",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>{t("totalCashInDrawer")}:</span>
          <span>
            {settings.curSymbol}{" "}
            {(values.totalCashInDrawer || 0).toFixed(settings.decimal)}
          </span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{t("totalOtherPayments")}:</span>
          <span>
            {settings.curSymbol}{" "}
            {(values.totalOtherPayments || 0).toFixed(settings.decimal)}
          </span>
        </div>
        {values.totalCreditSale > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              {t("creditSale")} ({t("due")}):
            </span>
            <span>
              (-) {settings.curSymbol}{" "}
              {(values.totalCreditSale || 0).toFixed(settings.decimal)}
            </span>
          </div>
        )}
      </div>

      {/* Payment Summary */}
      <div
        style={{
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: "8px",
          }}
        >
          {t("paymentSummery")}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textTransform: "uppercase",
          }}
        >
          <span>{t("openingBalance")}:</span>
          <span>
            {settings.curSymbol}{" "}
            {(values.openingBalance || 0).toFixed(settings.decimal)}
          </span>
        </div>
        {values.closeRegPayments &&
          values.closeRegPayments.map((p, ind) => (
            <div
              key={ind}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <span>
                {p.payMethodName} {t("sales")}:
              </span>
              <span>
                {settings.curSymbol}{" "}
                {(p.totalAmount || 0).toFixed(settings.decimal)}
              </span>
            </div>
          ))}
      </div>

      {/* Footer */}
      <div
        style={{
          textAlign: "center",
          fontSize: "10px",
          color: "#00000",
          lineHeight: 1.3,
          borderTop: "2px double #333",
          paddingTop: "10px",
        }}
      >
        <div>{t("thankYouForYourBusiness")}</div>
        <div style={{ marginTop: "5px", fontWeight: "bold" }}>
          {values.id ? "REGISTER CLOSED" : "IN PROGRESS"}
        </div>
      </div>
    </div>
  );
};

export default MinimalPrintReceipt;
